import { Box, Grid } from "@mui/material";
import { H5 } from "../../../styles";
import PatientAdmissionTitleAndInput from "../../form/PatientAdmissionTitleAndInput";

type Props = {};

const AgeSelection = (props: Props) => {
  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", margin: "0 -8px" }}>
        <Box
          sx={{
            width: "33.33%",
            padding: "12px 8px 0",
            "@media (max-width: 991px)": {
              width: "100%",
              padding: "0 8px 0",
            },
          }}
        >
          <PatientAdmissionTitleAndInput
            title="Age (year)*"
            name="year"
            placeholder="year"
            type="number"
            min="0"
          />
        </Box>
        <Box
          sx={{
            width: "33.33%",
            padding: "12px 8px 0",
            "@media (max-width: 991px)": {
              width: "100%",
              padding: "0 8px 0",
            },
          }}
        >
          <PatientAdmissionTitleAndInput
            title="Month*"
            name="month"
            placeholder="Month"
            type="number"
            min="0"
          />
        </Box>
        <Box
          sx={{
            width: "33.33%",
            padding: "12px 8px 0",
            "@media (max-width: 991px)": {
              width: "100%",
              padding: "0 8px 0",
            },
          }}
        >
          <PatientAdmissionTitleAndInput
            title="Day*"
            name="day"
            placeholder="Day"
            type="number"
            min="0"
          />
        </Box>
      </Box>
    </>
  );
};

export default AgeSelection;
